import { pipe } from 'fp-ts/lib/function';
import { array, failure, parse, success } from 'io-ts/Decoder';
import includes from 'lodash-es/includes';

import { constants } from '@bedc/constants';

import { Scope } from './Scope';

export const Scopes = pipe(
	array(Scope),
	parse((scopes) => {
		if (!scopes.length) {
			return failure(scopes, 'at least one scope is needed');
		}

		if (scopes.filter((s) => s.type === 'system').length > 1) {
			return failure(scopes, 'cannot have more than one system scope');
		}

		if (scopes.find((s) => s.type === 'system')) {
			const filteredScopes = scopes.filter((s) => s.type === 'system');

			if (filteredScopes.length > 1) {
				return failure(scopes, 'not have more than one scope with type system');
			}

			if (scopes.length > 1) {
				return failure(scopes, 'not have more than one scope with a system scope');
			}

			// oxlint-disable-next-line @typescript-eslint/no-non-null-assertion
			const scope = filteredScopes[0]!;

			if (!includes(constants.acs.devUserGroups, scope.userGroup)) {
				return failure(scopes, 'Invalid userGroup for system scope');
			}
		}

		if (scopes.filter((s) => s.type === 'country').length > 1) {
			return failure(scopes, 'cannot have more than one country scope');
		}

		if (scopes.find((s) => s.type === 'country')) {
			const filteredScopes = scopes.filter((s) => s.type === 'country');

			if (filteredScopes.length > 1) {
				return failure(
					scopes,
					'cannot have more than one scope defined with a country scope'
				);
			}

			// oxlint-disable-next-line @typescript-eslint/no-non-null-assertion
			const scope = filteredScopes[0]!;

			if (
				!includes(
					[
						...constants.acs.devUserGroups,
						'manager',
						'accounting',
						'hitl-specialist',
						'recipe-admin',
					],
					scope.userGroup
				)
			) {
				return failure(scopes, 'Invalid userGroup for country scope');
			}
		}

		if (scopes.find((s) => s.type === 'customer')) {
			const filteredScopes = scopes.filter((s) => s.type === 'customer');

			if (filteredScopes.length > 1) {
				return failure(
					scopes,
					'cannot have more than one scope defined with a customer scope'
				);
			}

			// oxlint-disable-next-line @typescript-eslint/no-non-null-assertion
			const scope = filteredScopes[0]!;

			if (!['customer'].includes(scope.userGroup)) {
				return failure(scopes, 'Invalid userGroup for customer scope');
			}
		}

		// franchise scope: at most one, no userGroup allowlist
		// (same restrictions as the organization scope)
		if (scopes.filter((s) => s.type === 'franchise').length > 1) {
			return failure(scopes, 'cannot have more than one franchise scope');
		}

		// principal scope: at most one, no userGroup allowlist
		// (same restrictions as the organization scope)
		if (scopes.filter((s) => s.type === 'principal').length > 1) {
			return failure(scopes, 'cannot have more than one principal scope');
		}

		return success(scopes);
	})
);
